import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { useIsAuthenticated } from "@azure/msal-react";

const PrivateRoute = ({ component: Component, render, ...rest }) => {
    const isAuthenticated = useIsAuthenticated();

    return (
        <Route
            {...rest}
            render={props => {
                if (!isAuthenticated && !localStorage.getItem('token')) {
                    const destination = props.location.pathname + props.location.search;
                    localStorage.setItem('destination', destination);
                    return <Redirect to={{ pathname: '/login', state: { from: props.location } }} />;
                } else {
                    return render ? render(props) : <Component {...props} />;
                }
            }}
        />
    );
};

export default PrivateRoute;